module.exports = __webpack_public_path__ + "img/bg-image.4cea9a58.png";